"use strict";

var novicell = novicell || {};

novicell.tabs = novicell.tabs || new function() {
    var classActiveTabDesktop = "o-tabsElement__tab--active-desktop";
    var classActiveTabMobile = "o-tabsElement__tab--active-mobile";
    var classActiveContentDesktop = "o-tabsElement__content--active-desktop";
    var classActiveContentMobile = "o-tabsElement__content--active-mobile";
    function init() {
        classNameHandler();
        
        window.addEventListener("resize", function () {
            classNameHandler();
        });
    }
    function classNameHandler(){
        var activeDesktopTab = document.querySelector('.'+classActiveTabDesktop);
        if (activeDesktopTab == null) {
            var tab1 = document.querySelector(".o-tabsElement__menu .o-tabsElement__tab");
            var content1 = document.querySelector(".o-tabsElement__menu .o-tabsElement__content");

            if(tab1 != null){
                tab1.classList.add(classActiveTabDesktop);
            }
            if(content1 != null){
                content1.classList.add(classActiveContentDesktop);
            }
        }
    }
    
    function openTab(source ) {
        var classIconOpen = "o-tabsElement__bar--open";
        var classIconVerticalSign = "o-tabsElement__bar--vertical";
        var i;
        var tabsTarget = document.getElementById("tab-" + source);
        var content = document.getElementsByClassName("o-tabsElement__content");
        var tabs = document.getElementsByClassName("o-tabsElement__tab");
        var wtclean = document.getElementsByClassName(classIconVerticalSign);
        var target = document.getElementById(source);
        var iconbox = tabsTarget.querySelector("." + classIconVerticalSign);
        var w = window.innerWidth;
        //der bliver trykket på en ikke allerede aktiv tab i det pågældende breakpoint
        if(w < 768 && !tabsTarget.classList.contains(classActiveTabMobile) || w > 767 && !tabsTarget.classList.contains(classActiveTabDesktop)){
            //luk alle og åbn en ny
            for (i = 0; i < tabs.length; i++) {
                tabs[i].classList.remove(classActiveTabDesktop);
                tabs[i].classList.remove(classActiveTabMobile);
            }
            for (i = 0; i < content.length; i++) {
                content[i].classList.remove(classActiveContentDesktop);
                content[i].classList.remove(classActiveContentMobile);
            }
            for (i = 0; i < wtclean.length; i++) {
                wtclean[i].classList.remove(classIconOpen);
            }

            tabsTarget.classList.add(classActiveTabDesktop);
            tabsTarget.classList.add(classActiveTabMobile);
            
            target.classList.add(classActiveContentDesktop);
            target.classList.add(classActiveContentMobile);
            if(iconbox!=null){
                iconbox.classList.add(classIconOpen);
            }
        }
        else if(w < 768 && tabsTarget.classList.contains(classActiveTabMobile)){
            //luk den aktuelle i mobile
            tabsTarget.classList.remove(classActiveTabDesktop);
            tabsTarget.classList.remove(classActiveTabMobile);
            
            target.classList.remove(classActiveContentDesktop);
            target.classList.remove(classActiveContentMobile);
            if(iconbox!=null){
                iconbox.classList.remove(classIconOpen);
            }
        }
    }
    
    return { init: init, openTab: openTab };
}();
